import {
    Flex,
    Box,
    FormLabel,
    Input,
    Button,
    useToast
} from '@chakra-ui/react'
import { addDoc, collection } from 'firebase/firestore'
import React, { useState } from 'react'
import db from '../firebase'

function AddTeam() {

    const [data, setData] = useState({})
    const toast = useToast()

    const handleChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    const postData = async () => {

        toast({
            position: 'bottom-right',
            title: `Adding Team`,
            duration: 1000,
            isClosable: true,
        })
        
        await addDoc(collection(db, 'teams'), {...data})
        setData({})
    }

    return (

        <Flex
            direction={'column'}
        >

        <Flex
            w={'full'}
            justifyContent={'center'}
            direction={'row'}
            wrap={'wrap'}
            mx={'auto'}
            p={10}
            gap={10}
        >
            <Box w={'30%'}>
                <FormLabel htmlFor='name'>Team Name</FormLabel>
                <Input  
                    id='name' 
                    type='text' 
                    name="name"
                    value={data?.name || ""}
                    onChange={(e) =>handleChange(e)}
                />
            </Box>
            
            
        </Flex>

            <Button mx={"auto"} w={'90%'} onClick={postData}>Submit</Button>

        </Flex>
    )
}

export default AddTeam